import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import LocationIcon from 'assets/svgs/Location.svg';

const Map = ({ center }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
      'AIzaSyD_YdazrKeGu2ungcbKIF8cLcOsPYYIEIc',
  });

  // Sites can be created without coordinates (latitude/longitude are optional
  // in the API), so center can arrive as { lat: undefined, lng: undefined }.
  // Passing that to Google Maps throws "InvalidValueError: setCenter/setPosition
  // ... lat: not a number". Coerce to numbers and only render the map when both
  // are finite; otherwise fall back to the location placeholder.
  const lat = Number(center?.lat);
  const lng = Number(center?.lng);
  const hasValidCoords = Number.isFinite(lat) && Number.isFinite(lng);

  if (!isLoaded || !hasValidCoords) {
    return (
      <div 
        className="flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100 relative overflow-hidden"
        style={{ width: '100px', height: '100px', borderRadius: '20px' }}
      >
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `linear-gradient(rgba(76, 175, 80, 0.1) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(76, 175, 80, 0.1) 1px, transparent 1px)`,
          backgroundSize: '10px 10px'
        }}></div>
        
        {/* Location pin icon */}
        <div className="relative z-10 flex flex-col items-center animate-pulse">
          <img 
            src={LocationIcon} 
            alt="map" 
            className="w-8 h-8 filter drop-shadow-md"
          />
        </div>
      </div>
    );
  }

  return (
    <GoogleMap
      center={{ lat, lng }}
      zoom={10}
      mapContainerStyle={{ width: '100px', height: '100px', borderRadius: '20px' }}
    >
      <Marker position={{ lat, lng }} />
    </GoogleMap>
  );
};

export default Map;
